import React from 'react';
import {
	Box,
	ToggleButton,
	ToggleButtonGroup,
	Typography,
} from '@mui/material';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PaymentsIcon from '@mui/icons-material/Payments';

const BidFormatToggle = ({ value, onChange, disabled = false }) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			gap: 1.5,
			flexWrap: 'wrap',
		}}
	>
		<Box sx={{ minWidth: 0 }}>
			<Typography variant="subtitle2" fontWeight={700}>
				Proposal format
			</Typography>
			<Typography variant="caption" color="text.secondary">
				Switch anytime before sending
			</Typography>
		</Box>
		<ToggleButtonGroup
			exclusive
			size="small"
			value={value ? 'itemized' : 'lump_sum'}
			onChange={(_, next) => {
				if (next !== null) {
					onChange(next === 'itemized');
				}
			}}
			disabled={disabled}
			sx={{
				bgcolor: 'action.hover',
				borderRadius: 999,
				p: 0.25,
				'& .MuiToggleButton-root': {
					border: 0,
					borderRadius: 999,
					px: 1.5,
					py: 0.75,
					textTransform: 'none',
					fontWeight: 600,
					fontSize: '0.8125rem',
					gap: 0.75,
					color: 'text.secondary',
					'&.Mui-selected': {
						bgcolor: 'background.paper',
						color: 'text.primary',
						boxShadow: 1,
						'&:hover': {
							bgcolor: 'background.paper',
						},
					},
				},
			}}
		>
			<ToggleButton value="lump_sum" aria-label="Full amount bid">
				<PaymentsIcon sx={{ fontSize: 16 }} />
				Full amount
			</ToggleButton>
			<ToggleButton value="itemized" aria-label="Itemized bid">
				<FormatListBulletedIcon sx={{ fontSize: 16 }} />
				Itemized
			</ToggleButton>
		</ToggleButtonGroup>
	</Box>
);

export default BidFormatToggle;
